export default __webpack_public_path__ + "static/media/hidden-hour.e8e1737c.jpg";